"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function Philosophy() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: circleRef,
    isVisible: circleVisible
  } = useRevealOnScroll<SVGSVGElement>({
    threshold: 0.3
  });
  return <section data-section-id="16102" id="the-nomoco-standard" className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
          {}
          <div ref={leftRef} className="md:col-span-6 transition-all duration-700 ease-out" style={{
          opacity: leftVisible ? 1 : 0,
          transform: leftVisible ? "translateY(0)" : "translateY(16px)"
        }}>
            <div className="relative mx-auto">
              {}
              

              {}
              <div className="relative">
                <div className="w-full overflow-hidden">
                  <img class=" shadow-lg" src="https://nomocopillow.com/wp-content/uploads/2026/06/nomocogroup.webp" alt="NoMoCo Pillow neuroimaging patient positioning system with memory foam support pads for reducing motion during brain MRI scans" />
                </div>
              </div>

              {}
              <p className="mt-6 text-center md:text-left text-xl text-accent-foreground" style={{
              fontFamily: "var(--font-default)",
              fontStyle: "italic"
            }}>
                NoMoCo Support — precision engineered for patient stability.
              </p>
            </div>
          </div>

          {}
          <div ref={rightRef} className="md:col-span-6 md:pt-20 transition-all duration-700 ease-out" style={{
          opacity: rightVisible ? 1 : 0,
          transform: rightVisible ? "translateY(0)" : "translateY(16px)"
        }}>
            <p className="font-default text-xs uppercase tracking-widest mb-6 text-primary" style={{
            letterSpacing: "0.18em"
          }}>// ABOUT US</p>

            <h2 className="font-default relative mb-10 text-primary !font-bold" style={{
            fontFamily: "var(--font-default)",
            fontWeight: 700,
            fontSize: "clamp(2.25rem, 4.5vw, 4rem)",
            lineHeight: 1.04,
            letterSpacing: "-0.02em"
          }}>Comfort, Confidence and Clarity.</h2>

            <div className="space-y-6 max-w-[480px] text-foreground" style={{
            fontSize: "clamp(1.05rem, 1.2vw, 1.2rem)",
            lineHeight: 1.7
          }}>
              <p>Comfort, Confidence, and Clarity combines the primary needs of both patient and health care professionals to make the imaging experience a positive one.</p>
              <p>
                Technology is essential, but the interface between patient and equipment is where care 
                happens. Our support systems are designed to provide stability, comfort, and reliability, 
                reducing motion artifacts and improving the overall clinical workflow.
              </p>
              <p>
                Our commitment is to the medical community. By providing tools that prioritize both 
                clinical precision and patient comfort, we help imaging professionals focus on what 
                matters most: accurate diagnosis and exceptional patient care.
              </p>
            </div>

            <div className="mt-10">
              <Link to="/product/" className="group inline-flex items-center gap-2 text-primary font-bold relative">
                <span className="relative">
                  View our product specifications
                  <span className="absolute left-0 -bottom-1 h-[2px] bg-primary transition-all duration-300 ease-out w-0 group-hover:w-full" aria-hidden="true" />
                </span>
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" style={{
                color: "var(--color-primary)"
              }} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}